// src/filterConfig.js
export const BLOCKED_TUTORIALS = [
  {
    author: "La Quarta Corda",
    platform: "YouTube",
  },
];
